import pako from 'pako';

const deflate = (data: any) => {
	const encode = new TextEncoder().encode(JSON.stringify(data));
	return pako.deflate(encode);
}

export default deflate;